// src/redux/slices/restaurantSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Restaurant } from '../../types/restaurant';
import { setRestaurantId, clearRestaurantId } from '../../api/tokenUtils';

interface RestaurantState {
  restaurants: Restaurant[];
  selectedRestaurant: Restaurant | null;
  loading: boolean;
  error: string | null;
}

const initialState: RestaurantState = {
  restaurants: [],
  selectedRestaurant: null,
  loading: false,
  error: null,
};

export const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState,
  reducers: {
    // Fetch restaurants actions
    fetchRestaurantsRequest: state => {
      state.loading = true;
      state.error = null;
    },
    fetchRestaurantsSuccess: (state, action: PayloadAction<Restaurant[]>) => {
      state.loading = false;
      state.restaurants = action.payload;
      state.error = null;
    },
    fetchRestaurantsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.restaurants = [];
    },

    // Select restaurant
    selectRestaurant: (state, action: PayloadAction<string>) => {
      const restaurant = state.restaurants.find(
        (r: Restaurant) => r.restaurant_id === action.payload
      );
      if (restaurant) {
        state.selectedRestaurant = restaurant;
        // Store restaurant ID in localStorage for persistence across page refreshes using tokenUtils
        setRestaurantId(restaurant.restaurant_id);
      }
    },

    // Clear selected restaurant only
    clearSelectedRestaurant: state => {
      state.selectedRestaurant = null;
      // Clear restaurant ID from localStorage using tokenUtils
      clearRestaurantId();
    },
  },
});

export const {
  fetchRestaurantsRequest,
  fetchRestaurantsSuccess,
  fetchRestaurantsFailure,
  selectRestaurant,
  clearSelectedRestaurant,
} = restaurantSlice.actions;

export default restaurantSlice.reducer;
